import { Broadband } from '../../types/property';

type BroadbandDataRow = {
  label: string;
  download: string;
  upload: string;
  availability: boolean;
  fibrus?: boolean;
};

const formatSpeed = (speed: string | null) => {
  if (speed) return `${speed} Mbps`;

  return `N/A`;
};

const formatBroadbandData = (broadband: Broadband): BroadbandDataRow[] => {
  const rows: BroadbandDataRow[] = [
    {
      label: 'Standard',
      download: formatSpeed(broadband.maxBbPredictedDown),
      upload: formatSpeed(broadband.maxBbPredictedUp),
      availability: !!broadband.maxBbPredictedDown,
    },
    {
      label: 'Superfast',
      download: formatSpeed(broadband.maxSfbbPredictedDown),
      upload: formatSpeed(broadband.maxSfbbPredictedUp),
      availability: !!broadband.maxSfbbPredictedDown,
    },
    {
      label: 'Ultrafast',
      download: formatSpeed(broadband.maxUfbbPredictedDown),
      upload: formatSpeed(broadband.maxUfbbPredictedUp),
      availability: !!broadband.maxUfbbPredictedDown,
    },
  ];

  if (broadband.fibrusAvailable) {
    rows.push({
      label: 'Fibrefast with',
      download: formatSpeed(broadband.maxFibrusDown),
      upload: formatSpeed(broadband.maxFibrusUp),
      availability: true,
      fibrus: true,
    });
  }

  return rows;
};

export default formatBroadbandData;
